/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Perm_Bypass_SlowmodeInputs */



/**
* | output |
* | --- |
* | "Bypass Slowmode" |
*
* @param {Leveling_Perm_Bypass_SlowmodeInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_perm_bypass_slowmode = /** @type {((inputs?: Leveling_Perm_Bypass_SlowmodeInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Perm_Bypass_SlowmodeInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обходить медленный режим")
	return /** @type {LocalizedString} */ ("Bypass Slowmode")
});